export const REMOVE_SECTION_FILTERS = 'REPORTING_REMOVE_SECTION_FILTERS';

export const FILTER_TYPES = {
  THEMATIC: 'thematic',
  NORMAL: 'normal',
};

export const removeSectionFilters = (filterType, filterValues) => ({
  type: REMOVE_SECTION_FILTERS,
  filterType,
  filterValues,
});
